import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("更多菜单")

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ElIcon } from 'element-plus'
import SvgIcon from '@/components/SvgIcon/index.vue'

// 隐藏侧边栏路由
interface RouteItem {
  path: string
  hidden?: boolean
  children?: RouteItem[]
  parentPath?: string
  meta?: {
    title: string
    icon?: string
    link?: boolean
    breadcrumb?: boolean
  }
  name?: string
  query?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const hideList = ['/index', '/user/profile']

const router = useRouter()
const route = useRoute()
const store = useStore()

// 顶部栏初始数
const visibleNumber = ref(5)
// 当前激活菜单的 index
const currentIndex = ref<string | undefined>(undefined)

// 主题
const theme = computed(() => store.state.settings.theme)

// 顶部显示菜单
const topMenus = computed(() => {
  const topMenus: RouteItem[] = []
  routers.value.map((menu) => {
    if (menu.hidden !== true) {
      // 兼容顶部栏一级菜单内部跳转
      if (menu.path === "/") {
        menu.children && topMenus.push(menu.children[0])
      } else {
        topMenus.push(menu)
      }
    }
  })
  return topMenus
})

// 所有的路由信息
const routers = computed(() => {
  return store.state.permission.topbarRouters as RouteItem[]
})

// 设置子路由
const childrenMenus = computed(() => {
  const childrenMenus: RouteItem[] = []
  routers.value.map((router) => {
    if (router.children) {
      for (const item in router.children) {
        if (router.children[item].parentPath === undefined) {
          if (router.path === "/") {
            router.children[item].path = "/" + router.children[item].path
          } else {
            if (!ishttp(router.children[item].path)) {
              router.children[item].path = router.path + "/" + router.children[item].path
            }
          }
          router.children[item].parentPath = router.path
        }
        childrenMenus.push(router.children[item])
      }
    }
  })
  return (window as any).constantRoutes.concat(childrenMenus)
})

// 默认激活的菜单
const activeMenu = computed(() => {
  const path = route.path
  let activePath = path
  if (path !== undefined && path.lastIndexOf("/") > 0 && hideList.indexOf(path) === -1) {
    const tmpPath = path.substring(1, path.length)
    activePath = "/" + tmpPath.substring(0, tmpPath.indexOf("/"))
    if (!route.meta.link) {
      store.dispatch('app/toggleSideBarHide', false)
    }
  } else if (!route.children) {
    activePath = path
    store.dispatch('app/toggleSideBarHide', true)
  }
  activeRoutes(activePath)
  return activePath
})

onMounted(() => {
  window.addEventListener('resize', setVisibleNumber)
  setVisibleNumber()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', setVisibleNumber)
})

// 根据宽度计算设置显示栏数
function setVisibleNumber() {
  const width = document.body.getBoundingClientRect().width / 3
  visibleNumber.value = parseInt((width / 85).toString())
}

// 菜单选择事件
function handleSelect(key: string) {
  currentIndex.value = key
  const route = routers.value.find(item => item.path === key)
  if (ishttp(key)) {
    // http(s):// 路径新窗口打开
    window.open(key, "_blank")
  } else if (!route || !route.children) {
    // 没有子路由路径内部打开
    const routeMenu = childrenMenus.value.find(item => item.path === key)
    if (routeMenu && routeMenu.query) {
      let query = JSON.parse(routeMenu.query)
      router.push({ path: key, query: query })
    } else {
      router.push({ path: key })
    }
    store.dispatch('app/toggleSideBarHide', true)
  } else {
    // 显示左侧联动菜单
    activeRoutes(key)
    store.dispatch('app/toggleSideBarHide', false)
  }
}

// 当前激活的路由
function activeRoutes(key: string) {
  const routes: RouteItem[] = []
  if (childrenMenus.value && childrenMenus.value.length > 0) {
    childrenMenus.value.map((item) => {
      if (key == item.parentPath || (key == "index" && "" == item.path)) {
        routes.push(item)
      }
    })
  }
  if (routes.length > 0) {
    store.commit("SET_SIDEBAR_ROUTERS", routes)
  } else {
    store.dispatch('app/toggleSideBarHide', true)
  }
}

function ishttp(url: string) {
  return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": _unref(activeMenu),
    mode: "horizontal",
    onSelect: handleSelect
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topMenus), (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (index < visibleNumber.value)
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 0,
                style: _normalizeStyle({'--theme': _unref(theme)}),
                index: item.path
              }, {
                default: _withCtx(() => [
                  (item.meta && item.meta.icon && item.meta.icon !== '#')
                    ? (_openBlock(), _createBlock(_unref(ElIcon), { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            "icon-class": item.meta.icon
                          }, null, 8, ["icon-class"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(item.meta.title), 1)
                ]),
                _: 2
              }, 1032, ["style", "index"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      (_unref(topMenus).length > visibleNumber.value)
        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 0,
            style: _normalizeStyle({'--theme': _unref(theme)}),
            index: "more"
          }, {
            title: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topMenus), (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `more-${index}`
                }, [
                  (index >= visibleNumber.value)
                    ? (_openBlock(), _createBlock(_component_el_menu_item, {
                        key: 0,
                        index: item.path
                      }, {
                        default: _withCtx(() => [
                          (item.meta && item.meta.icon && item.meta.icon !== '#')
                            ? (_openBlock(), _createBlock(_unref(ElIcon), { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(SvgIcon, {
                                    "icon-class": item.meta.icon
                                  }, null, 8, ["icon-class"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(item.meta.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["index"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 8, ["style"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})